class DetailsDisclosure extends HTMLElement {
  shouldLockScroll = true;

  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    if ('ontouchstart' in window) {
      this.mainDetailsToggle.querySelector('summary').addEventListener('touchenter', this.onHover.bind(this));
    } else {
      this.mainDetailsToggle.querySelector('summary').addEventListener('mouseenter', this.onHover.bind(this));
    }
    this.mainDetailsToggle.addEventListener('mouseleave', this.onUnhover.bind(this));
  }

  onHover() {
    this.open();
  }

  onUnhover() {
    this.close();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    let sliderComponent = this.mainDetailsToggle.querySelector('custom-slider-component');
    if (sliderComponent) {
      sliderComponent.dispatchEvent(new CustomEvent('slider-shown'));
    }
    this.playAnimations();

    if (this.shouldLockScroll) {
      document.body.classList.add('overflow-hidden');
    }
    document.body.classList.add('global-backdrop');

  }

  close() {
    if (this.mainDetailsToggle.hasAttribute('constantly-open') === false) {
      this.mainDetailsToggle.removeAttribute('open');
    }
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.cancelAnimations();

    if (this.shouldLockScroll) {
      document.body.classList.remove('overflow-hidden');
    }
    document.body.classList.remove('global-backdrop');
  }

  playAnimations() {
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  cancelAnimations() {
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.cancel());
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  shouldLockScroll = false;

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onUnhover() {
    if (!this.header) return;
    this.header.preventHide = false;
    this.close();
  }
}

customElements.define('header-menu', HeaderMenu);
